import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Bar, ResponsiveContainer, ComposedChart, ReferenceLine, LabelList  } from "recharts";
import { CustomTooltip, CustomizedTick, generateSymmetricTicksAndDomain, generatePositiveIntegerTicksAndDomain } from "../ChartUtils";

const AribaLineThreeColoredBarChart = ({ linebarchartData }) => {

const sortedData = linebarchartData.map(item => ({
  ...item,
  total: (item.RFI || 0) + (item.RFP || 0) + (item.AUCTION || 0)
}));

// /* istanbul ignore next */
// function getRoundingBase(value) {
//   const absValue = Math.abs(value);
//   if (absValue < 1) return 0.1;
//   if (absValue < 10) return 1;
//   if (absValue < 100) return 5;
//   if (absValue < 1000) return 10;
//   return 100;
// }

// /* istanbul ignore next */
// function roundUpToNearest(value, base) {
//   return Math.ceil(value / base) * base;
// }

// function roundDownToNearest(value, base) {
//   return Math.floor(value / base) * base;
// }

// Symmetric ticks and domain (same as before)

// function generateSymmetricTicksAndDomain(maxValue, tickCount = 9) {
//   const intervalCount = tickCount - 1;
//   const step = roundUpToNearest((2 * maxValue) / intervalCount, getRoundingBase(maxValue));
//   const domainMax = step * Math.floor(intervalCount / 2);
//   const domainMin = -domainMax;

//   const ticks = [];
//   if(step !== 0){
//     for (let i = domainMin; i <= domainMax; i += step) {
//       // ticks.push(i);
//       ticks.push(Number(i.toFixed(2)));
//     }
//   }
//   return { ticks, domainMin, domainMax };
// }

// NEW: Positive integer ticks and domain generator

// function generatePositiveIntegerTicksAndDomain(maxValue, tickCount = 5) {
//   const domainMax = Math.ceil(maxValue); // round up to integer
//   const intervalCount = tickCount - 1;
//   const step = Math.ceil(domainMax / intervalCount); // integer step

//   const adjustedDomainMax = step * intervalCount; // ensure max is multiple of step
//   const domainMin = 0;

//   const ticks = [];
//   if(step !== 0){
//     for (let i = domainMin; i <= adjustedDomainMax; i += step) {
//       // ticks.push(i);
//       ticks.push(Number(i.toFixed(2)));
//     }
//   }

//   return { ticks, domainMin, domainMax: adjustedDomainMax };
// }

// ===== Main Tick & Domain Logic =====

// Your data input
const primaryValues = linebarchartData?.flatMap(item => [
  parseFloat(item?.RFI || 0)+parseFloat(item?.RFP || 0)+parseFloat(item?.AUCTION || 0),
]);

const secondaryValues = linebarchartData?.map(item => parseFloat(item.projects));

// Raw min/max
const minPrimaryValue = Math.min(...primaryValues);
const maxPrimaryValue = Math.max(...primaryValues);
const minSecondaryValue = Math.min(...secondaryValues);
const maxSecondaryValue = Math.max(...secondaryValues);

// Determine if negative domain needed for BOTH based on either minPrimary or minSecondary
const needSymmetricDomain = (minPrimaryValue < 0 || minSecondaryValue < 0);

const absMaxPrimary = Math.max(Math.abs(minPrimaryValue), Math.abs(maxPrimaryValue));
const absMaxSecondary = Math.max(Math.abs(minSecondaryValue), Math.abs(maxSecondaryValue));

let {
  ticks: primaryTicks,
  domainMin: primaryDomainMin,
  domainMax: primaryDomainMax
} = needSymmetricDomain
  ? generateSymmetricTicksAndDomain(absMaxPrimary)
  : generatePositiveIntegerTicksAndDomain(maxPrimaryValue);

let {
  ticks: secondaryTicks,
  domainMin: secondaryDomainMin,
  domainMax: secondaryDomainMax
} = needSymmetricDomain
  ? generateSymmetricTicksAndDomain(absMaxSecondary)
  : generatePositiveIntegerTicksAndDomain(maxSecondaryValue);

  if(absMaxPrimary == 0){
    primaryTicks = secondaryTicks
    primaryDomainMin = secondaryDomainMin
    primaryDomainMax = secondaryDomainMax
  }
  
  if(absMaxSecondary == 0){
    secondaryTicks = primaryTicks
    secondaryDomainMin = primaryDomainMin
    secondaryDomainMax = primaryDomainMax
  }

  // Calculate dynamic width
  const categoryCount = sortedData.length;
  const widthPerCategory = 100; // Base width for each category
  let calculatedWidth = categoryCount * widthPerCategory;

  if(calculatedWidth<=675) {
    calculatedWidth = 645;
  }
  return (
    <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
    <ResponsiveContainer width={calculatedWidth} height={400}>
    {/* <ResponsiveContainer width="100%" height={350}> */}
      <ComposedChart
        // width={calculatedWidth}
        data={sortedData}
        margin={{
          top: 20,
          right: 10,
          left: 10,
          bottom: 50,
        }}
      >
        <CartesianGrid horizontal={true} vertical={false} stroke="#DFDFDF" />

        <XAxis 
          dataKey="month" 
          tickLine={false} 
          tick={<CustomizedTick />} 
          
          interval={0}
        />

        {/* Primary Y Axis */}
        <YAxis
          yAxisId="left"
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
          // domain={[0, maxPrimaryValue]}
          domain={[primaryDomainMin, primaryDomainMax]}
          ticks={primaryTicks}
          // ticks={generateTicks(maxPrimaryValue)}
          // label={{
          //   value: "Annualized Estimated Spend (MN USD)",
          //   angle: -90,
          //   position: "insideLeft",
          //   textAnchor: "middle",
          //   dy: 140,
          //   style: { fontSize: "14px", fontWeight: "500", fill: "#616161" },
          // }}
        />

          <YAxis
            yAxisId="right"
            orientation="right"
            axisLine={false}
            tickLine={false}
            allowDecimals={false}
            // domain={[0, maxSecondaryValue]}
            domain={[secondaryDomainMin, secondaryDomainMax]}
            // ticks={generateTicks(maxSecondaryValue)}
            ticks={secondaryTicks}
            // ticks={minSecondaryValue >= 0 ? generateTicks(maxSecondaryValue) : generateTicksNegative(maxSecondaryValue, minSecondaryValue)}
            interval={0}
            tick={({ x, y, payload }) => (
              <text x={x} y={y + 4} textAnchor="start" fill="#666">
                {payload.value}
              </text>
            )}
            label={{
              value: "Projects",
              angle: -90,
              position: "insideRight",
              textAnchor: "middle",
              dy: -10,
              dx: 8,
              style: { fontSize: "14px", fontWeight: "500", fill: "#616161"},
            }}
          />

        <ReferenceLine y={0} stroke="#888888" yAxisId="right" />

                <Tooltip content={<CustomTooltip />} />


                <Bar yAxisId="left" dataKey="RFI" name="RFI" stackId="a" barSize={30} fill="#E66A00" />
                <Bar yAxisId="left" dataKey="RFP" name="RFP" stackId="a" barSize={30} fill="#800080" />
                <Bar yAxisId="left" dataKey="AUCTION" name="AUCTION" stackId="a" barSize={30} fill="#47554F">
                  <LabelList dataKey="total" position="top" className='ariba-coverage-bar-label'/>
                </Bar>
                {/* <Bar yAxisId="left" dataKey="FORWARD AUCTION" name="FORWARD AUCTION" stackId="a" barSize={30} fill="#0078A7" /> */}
                {/* Two Lines */}
                {/* <Line
                  yAxisId="right"
                  type="linear"
                  dataKey="projects"
                  name="Projects"
                  stroke="#FF891C"
                  dot={{ fill: "#FF891C", stroke: "#FF891C", strokeWidth: 2 }}
                  strokeWidth={3}
                />               */}
              </ComposedChart>
            </ResponsiveContainer>
         </div>
          );
        };

export default AribaLineThreeColoredBarChart;
